export enum DataSourceOptions {
  NoData = 'No Data',
  CMSData = 'CMS Data',
  Group = 'Group',
  CustomData = 'Custom Data',
  ExternalData = 'External Data',
}
